import { useEffect, useRef } from 'react'

export default function useResizeObserver<T extends HTMLElement>(
  element: T | null | undefined,
  callback: (entries: ResizeObserverEntry[]) => void
): void {
  const callbackRef = useRef<(entries: ResizeObserverEntry[]) => void>()
  callbackRef.current = callback

  useEffect(() => {
    if (!element) return

    const observer = new ResizeObserver((entries) => callbackRef.current?.(entries))
    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [element])
}
